import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import axios from '../../axios/axiosconf';

function ModalCIE10({ show, onClose, onSelect, title = "Seleccionar Código CIE10", zIndex = 20000 }) {
    const [cie10Data, setCie10Data] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const searchInputRef = useRef(null);

    // Cargar datos del backend cuando se abre el modal
    useEffect(() => {
        if (show && cie10Data.length === 0) {
            cargarCIE10();
        }
    }, [show, cie10Data.length]);

    // Filtrar datos cuando cambia el término de búsqueda
    useEffect(() => {
        if (searchTerm.trim() === '') {
            setFilteredData(cie10Data.slice(0, 100)); // Mostrar solo los primeros 100 inicialmente
        } else {
            const term = searchTerm.toUpperCase();
            const filtered = cie10Data.filter(item =>
                item.Codigo.toUpperCase().includes(term) ||
                item.Nombre.toUpperCase().includes(term)
            );
            setFilteredData(filtered.slice(0, 100)); // Limitar a 100 resultados
        }
    }, [searchTerm, cie10Data]);

    useEffect(() => {
        if (!show) return undefined;
        const t = setTimeout(() => {
            if (searchInputRef.current) {
                searchInputRef.current.focus();
            }
        }, 50);
        return () => clearTimeout(t);
    }, [show]);

    const cargarCIE10 = async () => {
        setLoading(true);
        try {
            // Obtener datos desde el backend usando el endpoint existente
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            const config = {
                headers: { Authorization: 'Bearer ' + userdata.access_token },
                params: { uid: userdata.user_id }
            };

            const response = await axios.get('/cie10-data', config);

            if (response.data && response.data.Cie10) {
                setCie10Data(response.data.Cie10);
                setFilteredData(response.data.Cie10.slice(0, 100)); // Mostrar primeros 100
            }
        } catch (error) {
            console.error('Error Cargando CIE 10/11:', error);
            alert('Hubo Un Problema Al Consultar Los Diagnósticos CIE-10/11. Por Favor, Revise Su Conexión A Internet E Intente De Nuevo..');
        } finally {
            setLoading(false);
        }
    };

    const handleSelect = (item) => {
        onSelect(item.Codigo);
        handleClose();
    };

    const handleClose = () => {
        setSearchTerm('');
        onClose();
    };

    if (!show) return null;

    return createPortal(
        <div
            className="modal fade show"
            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex }}
            tabIndex="-1"
            onMouseDown={(e) => e.stopPropagation()}
        >
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header bg-info">
                        <h5 className="modal-title text-white">
                            <i className="fas fa-search mr-2"></i>{title}
                        </h5>
                        <button type="button" className="close text-white" onClick={handleClose}>
                            <span>&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {/* Buscador */}
                        <div className="form-group">
                            <label><b>Buscar Por Código o Nombre:</b></label>
                            <input
                                ref={searchInputRef}
                                type="text"
                                className="form-control"
                                placeholder="Busque Por Nombre O Código Del Diagnóstico CIE-10/11.."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                onKeyDown={(e) => e.stopPropagation()}
                            />
                            <small className="form-text text-muted">
                                Mostrando {filteredData.length} de {cie10Data.length} códigos
                            </small>
                        </div>

                        {/* Tabla de resultados */}
                        <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            {loading ? (
                                <div className="text-center p-4">
                                    <div className="spinner-border text-info" role="status">
                                        <span className="sr-only">Cargando...</span>
                                    </div>
                                    <p className="mt-2">Cargando códigos CIE-10/11...</p>
                                </div>
                            ) : (
                                <table className="table table-hover table-sm">
                                    <thead className="thead-light" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                        <tr>
                                            <th style={{ width: '15%' }}>Código</th>
                                            <th style={{ width: '70%' }}>Nombre</th>
                                            <th style={{ width: '15%' }}>Acción</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredData.length > 0 ? (
                                            filteredData.map((item, index) => (
                                                <tr key={index}>
                                                    <td><strong>{item.Codigo}</strong></td>
                                                    <td>{item.Nombre}</td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-info"
                                                            onClick={() => handleSelect(item)}
                                                        >
                                                            <i className="fas fa-check"></i> Seleccionar
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="3" className="text-center text-muted">
                                                    {searchTerm ? 'No se encontraron resultados' : 'No hay datos disponibles'}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={handleClose}>
                            <i className="fas fa-times"></i> Cerrar
                        </button>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
}

export default ModalCIE10;
